import { useState } from "react";
import Button from "../../input/Button";
import useUserCompany from "../../../hooks/useUserCompany";

const JobMonitorAdvancedSearch = ({ searchResHandler, resetHanler }) => {
  const [reqNos, setReqNos] = useState("");
  const userCompany = useUserCompany();

  const onSearch = (e) => {
    e.preventDefault();
    console.log("In ADVANCE SEARCH");
    searchResHandler({
      lDataType: null,
      dFromData: null,
      dToDate: null,
      sCustomer: null,
      sShipper: null,
      sJobStatus: null,
      sJobNos: null,
      sRequestNos: reqNos,
      sVehicleNos: null,
      sFlaggedType: null,
      sResolved: null,
      sStatus: null,
      sActive: null,
      customerGroup: null,
      sTransporters: null,
      lCompany: userCompany.comId,
    });
  };

  const onReset = (e) => {
    e.preventDefault();
    setReqNos("");
    resetHanler();
  };
  return (
    <form className="ui form">
      <div className="field">
        <div className="ui icon input">
          <input
            type="text"
            placeholder="Request Numbers"
            name="reqnos"
            value={reqNos}
            onChange={(e) => {
              setReqNos(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearch(e);
              }
            }}
          />
          <i className="search icon"></i>
        </div>
        <div className="results"></div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "17px",
          }}
        >
          <div className="field" style={{ width: "100%" }}>
            <Button template="search" onClick={onSearch} />
            <Button template="searchReset" onClick={onReset} />
          </div>
        </div>
      </div>
    </form>
  );
};

export default JobMonitorAdvancedSearch;
